import React from 'react';
import _ from 'lodash';
import { Card, CardHeader, Box, CardContent, TextField, Stack, Typography } from '@mui/material';
import { useEmployees } from '../../EmployessContext';

export default function Settlement ({ formik }) {
  const { rowData } = useEmployees();
  console.log(rowData.applications);

  return (
    <Card>
      <CardHeader title="Rozliczenia"></CardHeader>
      <CardContent>
        <Stack direction="row" flexWrap="wrap" sx={{ marginTop: 4 }}>
          {rowData.applications?.map(item => <Card key={item.id} sx={{ width: '100%', marginBottom: 2, marginRight: 2 }}>
            <CardHeader title={item.function_type_display} sx={{ textTransform: 'capitalize' }}/>
            <CardContent sx={{ display: 'flex', flexDirection: 'row', gap: '50px' }}>
              <Stack spacing={3} sx={{ width: '300px' }}>
                <Typography>Do wypłaty: {!_.isNil(item.to_pay) ? <b>{item.to_pay} zł {!_.isNil(item.to_pay_net_or_gross) ? item.to_pay_net_or_gross === 'gross' ? '(brutto)' : '(netto)' : ''}</b> : null}</Typography>
                <Typography>Wypłacono: {!_.isNil(item.paid_sum) ? <b>{item.paid_sum} zł</b> : null}</Typography>
                <Typography>Pozostało do wypłaty: {!_.isNil(item.paid_sum) && !_.isNil(item.to_pay) ? <b>{Number(item.to_pay) - Number(item.paid_sum)} zł</b> : null}</Typography>
              </Stack>
              <Stack spacing={3} sx={{ width: '380px' }}>
                <Typography>Stawka dzienna: {!_.isNil(item.daily_rate) ? <b>{item.daily_rate} zł</b> : null}</Typography>
                <Typography>Stawka godzinowa styczeń-grudzień: {!_.isNil(item.hourly_rate) ? <b>{item.hourly_rate} zł</b> : null}</Typography>
                <Typography>Stawka godzinowa styczeń-czerwiec: {!_.isNil(item.hourly_rate_summer) ? <b>{item.hourly_rate_summer} zł</b> : null}</Typography>
                <Typography>Stawka godzinowa lipiec-grudzień: {!_.isNil(item.hourly_rate_winter) ? <b>{item.hourly_rate_winter} zł</b> : null}</Typography>
              </Stack>
              <Stack spacing={3}>
                <Typography>Bonus: {!_.isNil(item.bonus_sum) ? <b>{item.bonus_sum} zł</b> : null}</Typography>
                <Typography>Dodatki: {!_.isNil(item.supplements) ? <b>{item.supplements} zł</b> : null}</Typography>
                <Typography>Dodatki z tytułu: {!_.isNil(item.supplements_info) ? <b>{item.supplements_info}</b> : null}</Typography>
              </Stack>
            </CardContent>
          </Card>)}

        </Stack>
      </CardContent>
    </Card>
  );
}
